import React, { FC } from 'react';
import { Autoplay, FreeMode, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/bundle';

import bnrLp from '@/newcar/ui/top/img/topbanner/lp-bnr.png';
import bnrLpAvif from '@/newcar/ui/top/img/topbanner/lp-bnr.avif';
import uservoice from '@/newcar/ui/top/img/banners/uservoice.png';
import uservoiceAvif from '@/newcar/ui/top/img/banners/uservoice.avif';
import bnrLpTestA from '@/newcar/ui/top/img/fvtest250305/fv-nr-1.png';
import bnrLpTestAAvif from '@/newcar/ui/top/img/fvtest250305/fv-nr-1.avif';
import bnrLpTestB from '@/newcar/ui/top/img/fvtest250305/fv-nr-2.png';
import bnrLpTestBAvif from '@/newcar/ui/top/img/fvtest250305/fv-nr-2.avif';
import bnrLpTestC from '@/newcar/ui/top/img/fvtest250305/fv-nr-3.png';
import bnrLpTestCAvif from '@/newcar/ui/top/img/fvtest250305/fv-nr-3.avif';
import bnrLpTestD from '@/newcar/ui/top/img/fvtest250305/fv-nr-4.png';
import bnrLpTestDAvif from '@/newcar/ui/top/img/fvtest250305/fv-nr-4.avif';
import bnrLpTestE from '@/newcar/ui/top/img/fvtest250305/fv-nr-5.png';
import bnrLpTestEAvif from '@/newcar/ui/top/img/fvtest250305/fv-nr-5.avif';

const SwiperSp: FC = () => (
  <>
    <Swiper
      modules={[Autoplay, FreeMode, Pagination]}
      autoplay
      breakpoints={{
        320: {
          slidesPerView: 1,
        },
        769: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 1,
        },
      }}
      pagination={{
        clickable: true,
        el: '#pageDotsSp',
      }}
      loop
      spaceBetween={32}
      slidesPerView={6}
      speed={500}
    >
      <SwiperSlide>
        <a href="/pr/2025/newlife/" id="fvtest250305-cpn-original" data-gtm="gtm-newcar-top-bnr-cp-2">
          <picture>
            <source srcSet={bnrLpAvif} type="image/avif" />
            <img
              src={bnrLp}
              alt="最大3万円が当たる！春の新生活応援キャンペーン2025"
              width="343"
              height="61"
            />
          </picture>
        </a>
      </SwiperSlide>
      <SwiperSlide>
        <a href="/uservoice/" id="fvtest250305-cpn-original-lp" data-gtm="gtm-newcar-top-bnr-uservoice">
          <picture>
            <source srcSet={uservoiceAvif} type="image/avif" />
            <img
              src={uservoice}
              alt="お客様の声"
              width="343"
              height="60"
            />
          </picture>
        </a>
        {/* AB TEST 20250305 */}
        <a href="/docs/fee/" id="fvtest250305-1" className="is-hidden" data-gtm="gtm-newcar-top-bnr-saiyasu">
          <picture>
            <source srcSet={bnrLpTestAAvif} type="image/avif" />
            <img
              src={bnrLpTestA}
              alt=""
              width="343"
              height="60"
            />
          </picture>
        </a>
        <a href="/docs/moraeru/" id="fvtest250305-2" className="is-hidden" data-gtm="gtm-newcar-top-bnr-moraeru">
          <picture>
            <source srcSet={bnrLpTestBAvif} type="image/avif" />
            <img
              src={bnrLpTestB}
              alt=""
              width="343"
              height="60"
            />
          </picture>
        </a>
        <a href="/docs/ranking/" id="fvtest250305-3" className="is-hidden" data-gtm="gtm-newcar-top-bnr-ranking">
          <picture>
            <source srcSet={bnrLpTestCAvif} type="image/avif" />
            <img
              src={bnrLpTestC}
              alt=""
              width="343"
              height="60"
            />
          </picture>
        </a>
        <a href="/lp/207-ab-7/" id="fvtest250305-4" className="is-hidden" data-gtm="gtm-newcar-top-bnr-kaisetsu">
          <picture>
            <source srcSet={bnrLpTestDAvif} type="image/avif" />
            <img
              src={bnrLpTestD}
              alt=""
              width="343"
              height="60"
            />
          </picture>
        </a>
        <a href="/lp/207-ab-7/" id="fvtest250305-5" className="is-hidden" data-gtm="gtm-newcar-top-bnr-muiteru">
          <picture>
            <source srcSet={bnrLpTestEAvif} type="image/avif" />
            <img
              src={bnrLpTestE}
              alt=""
              width="343"
              height="60"
            />
          </picture>
        </a>
      </SwiperSlide>
    </Swiper>

    <div id="pageDotsSp" />
  </>
);

export default SwiperSp;
